import React from 'react';
import './PetAnimations.css';

export default function WolfSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#8B8B8B';
  const lightColor = color ? lighten(color) : '#B0B0B0';
  const darkColor = color ? darken(color) : '#5A5A5A';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Tail */}
      <path
        d="M88 72C98 65 108 52 104 44C101 38 96 42 95 48C93 56 90 66 85 72"
        stroke={bodyColor}
        strokeWidth="6"
        strokeLinecap="round"
        fill="none"
      />
      {/* Body */}
      <ellipse cx="60" cy="76" rx="30" ry="24" fill={bodyColor} />
      {/* Belly */}
      <ellipse cx="60" cy="82" rx="18" ry="14" fill={lightColor} />
      {/* Back legs */}
      <rect x="34" y="88" width="12" height="16" rx="6" fill={bodyColor} />
      <rect x="74" y="88" width="12" height="16" rx="6" fill={bodyColor} />
      {/* Paws */}
      <ellipse cx="40" cy="102" rx="7" ry="4" fill={darkColor} />
      <ellipse cx="80" cy="102" rx="7" ry="4" fill={darkColor} />
      {/* Front legs */}
      <rect x="42" y="90" width="10" height="14" rx="5" fill={bodyColor} />
      <rect x="68" y="90" width="10" height="14" rx="5" fill={bodyColor} />
      <ellipse cx="47" cy="102" rx="6" ry="3.5" fill={darkColor} />
      <ellipse cx="73" cy="102" rx="6" ry="3.5" fill={darkColor} />
      {/* Head */}
      <ellipse cx="60" cy="44" rx="24" ry="22" fill={bodyColor} />
      {/* Snout */}
      <ellipse cx="60" cy="52" rx="12" ry="9" fill={lightColor} />
      {/* Left ear */}
      <path d="M40 30L32 10L48 24Z" fill={bodyColor} />
      <path d="M41 28L35 14L47 25Z" fill="#E8A0A0" />
      {/* Right ear */}
      <path d="M80 30L88 10L72 24Z" fill={bodyColor} />
      <path d="M79 28L85 14L73 25Z" fill="#E8A0A0" />
      {/* Eyes */}
      <ellipse cx="50" cy="41" rx="4.5" ry="5" fill="white" />
      <ellipse cx="70" cy="41" rx="4.5" ry="5" fill="white" />
      <ellipse cx="51" cy="41" rx="3" ry="3.5" fill="#3A2810" />
      <ellipse cx="71" cy="41" rx="3" ry="3.5" fill="#3A2810" />
      <circle cx="52.5" cy="39.5" r="1.2" fill="white" />
      <circle cx="72.5" cy="39.5" r="1.2" fill="white" />
      {/* Nose */}
      <ellipse cx="60" cy="50" rx="3.5" ry="2.5" fill="#2C2419" />
      <ellipse cx="60" cy="49.5" rx="1.5" ry="0.8" fill="#4A4040" opacity="0.5" />
      {/* Mouth */}
      <path d="M60 52.5C60 52.5 56 56 54 55.5" stroke={darkColor} strokeWidth="1" strokeLinecap="round" fill="none" />
      <path d="M60 52.5C60 52.5 64 56 66 55.5" stroke={darkColor} strokeWidth="1" strokeLinecap="round" fill="none" />
      {/* Tongue */}
      <ellipse cx="60" cy="56" rx="3" ry="2.5" fill="#E87E7E" />
      {/* Collar */}
      <path d="M40 60C40 60 50 65 60 65C70 65 80 60 80 60" stroke="#D44" strokeWidth="3" strokeLinecap="round" fill="none" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
